// client/src/components/layout/WhatsAppButton.js
import React from 'react';
import './WhatsAppButton.css';

const WHATSAPP_NUMBER = '255769880769';
const DEFAULT_MESSAGE =
  'Hello Makah Medics, I would like to inquire about medical equipment and supplies.';

const WhatsAppButton = () => {
  const whatsappUrl = `https://wa.me/${WHATSAPP_NUMBER}?text=${encodeURIComponent(
    DEFAULT_MESSAGE
  )}`;

  return (
    <a
      href={whatsappUrl}
      target="_blank"
      rel="noopener noreferrer"
      className="floating-whatsapp-btn"
      aria-label="Chat with Makah Medics on WhatsApp (+255 769 880 769)"
    >
      <span className="whatsapp-pulse-ring" aria-hidden="true"></span>
      <i className="fab fa-whatsapp" aria-hidden="true"></i>
      <span className="whatsapp-tooltip">
        <strong>Chat with a Specialist</strong>
        <small>+255 769 880 769</small>
      </span>
    </a>
  );
};

export default WhatsAppButton;
